import "../../stylesheets/about-package/about.less";
import "../../stylesheets/shared-package/shared.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import PageRoot from "#app-shell-package/page-root.tsx";

import AboutHeader from "./about-header.tsx";
import AboutNav from "./about-nav.tsx";
import {withStrings} from "./locales/our-supporters/load-strings.tsx";
import Supporters from "./supporters.tsx";

type Props = Record<any, any>;

class SupportersPage extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <PageRoot settings={{title: t`Supporters`}}>
                <div className="about-page">
                    <AboutHeader pageheadline={t`Supporters`} />
                    <AboutNav aboutSelection="our-supporters" />
                    <div id="about-supporters">
                        <Supporters />
                    </div>
                </div>
            </PageRoot>
        );
    }
}

export default withStrings(SupportersPage);
